module.exports = __webpack_public_path__ + "img/menage.989f698c.png";